import { RouteRecordRaw } from "vue-router";

const adminRoutes: RouteRecordRaw[] = [
  {
    path: "/sf-admin",
    name: "SfAdminIndex",
    component: () => import("../views/sf-admin/SfAdminIndexView.vue"),
  },
  {
    path: "/sf-admin/view-as",
    name: "SfViewAs",
    component: () => import("../views/sf-admin/SfAdminViewAsView.vue"),
  },
  {
    path: "/sf-admin/games",
    name: "SfAdminGames",
    component: () => import("../views/sf-admin/SfAdminGamesView.vue"),
  },
  {
    path: "/sf-admin/maths-levels",
    name: "SfAdminLevels",
    component: () => import("../views/sf-admin/SfAdminMathLevelsView.vue"),
  },
  {
    path: "/sf-admin/schools",
    name: "SfAdminSchools",
    component: () => import("../views/sf-admin/SfAdminSchoolsView.vue"),
  },
  {
    path: "/sf-admin/individuals",
    name: "SfAdminIndividuals",
    component: () => import("../views/sf-admin/SfAdminIndividualsView.vue"),
  },
  {
    path: "/sf-admin/mf-join-request",
    name: "SfAdminMfJoinRequest",
    component: () => import("../views/sf-admin/MfRequestsView.vue"),
  },
  {
    path: "/sf-admin/user-alerts",
    name: "SfAdminUserAlerts",
    component: () => import("../views/sf-admin/UserAlertsView.vue"),
  },
  {
    path: "/sf-admin/invoices",
    name: "SfAdminInvoices",
    component: () => import("../views/sf-admin/SfAdminInvoicesView.vue"),
  },
  {
    path: "/sf-admin/school/subscriptions/:schoolId",
    name: "SfSchoolSubscriptions",
    component: () => import("../views/sf-admin/SfAdminSubscriptionsView.vue"),
  },
  {
    path: "/sf-admin/individual/subscriptions/:individualId",
    name: "SfIndividualSubscriptions",
    component: () => import("../views/sf-admin/SfAdminSubscriptionsView.vue"),
  },
  {
    path: "/sf-admin/expire-warnings",
    name: "SfAdminExpireWarnings",
    component: () => import("../views/sf-admin/SfAdminExpireWarningsView.vue"),
  }
];

export default adminRoutes;
